import { useShared } from '@procommerce/visitor';
import { computed } from 'vue';

export function useWishlistProducts() {
  const shared = useShared();

  return computed(() => shared.value.wishlist_variants);
}
